'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
import StoreLocator from './store-locator';
// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';
import translate      from '../_utils/tools/translate';

// -----------------------------------------------------------
//  Pickup
// -----------------------------------------------------------
const Pickup = ({deliveryTimes, open, disabled, hasOneHourPickup, leftArrowPosition}) => {
  const tier = hasOneHourPickup ? '1hr' : 'Same day';

  return (
    <aside className={ classNames('delivery-info', { 'd-none': !open }) }>
      <div className='arrow d-none d-md-block' style={ { left: leftArrowPosition } } />

      { disabled ? disabledContent(tier) : enabledContent(tier) }
    </aside>
  );

  function disabledContent() {
    return (
      <section className='delivery-info-section card-body'>
        <header className='header-bar'>
          <i className='far fa-clock'/><strong>{ tier } { translate('pickup') }</strong>
        </header>
        { tier } { translate('pickup') } is not available for your selection.
      </section>
    );
  }

  function enabledContent() {
    return (
      <section className='delivery-info-section card-body'>
        <header className='header-bar'>
          <i className='far fa-clock'/><strong>{ tier } { translate('pickup') }</strong>
        </header>
        <ul className="delivery-info-time">
          <li><strong>Free Pickup</strong></li>
          <li className='lower-space'>{ deliveryTimes['PICKUP'] && genericHelpers.calculateDeliveryDay(deliveryTimes['PICKUP']) }</li>
        </ul>
        <StoreLocator serviceFilter="SERVICE_PHOTO_CENTER_ONE_HOUR"
                      exactNote={ `You&apos;ll see exact ${translate('pickup')} hours when you checkout` } />
      </section>
    );
  }
};

export default Pickup;
